import { CALL_API } from 'redux-api-middleware'
import { replace } from 'react-router-redux'
import { token } from '../utils'
import {
  LOAD_COURSE_PAGES_REQUEST,
  LOAD_COURSE_PAGES_SUCCESS,
  LOAD_COURSE_PAGES_FAILURE,
  LOAD_PLAYLISTS_PLAYER,
  // SUBMIT_REVIEWS,
  SUBMIT_REVIEW_REQUEST,
  SUBMIT_REVIEW_SUCCESS,
  SUBMIT_REVIEW_FAILURE,
  DELETE_REVIEW_REQUEST,
  DELETE_REVIEW_SUCCESS,
  DELETE_REVIEW_FAILURE,
  CANCEL_REVIEW_DIALOG,
  CANCEL_REMOVE_REVIEW_DIALOG,
  PAYMENT_REQUEST,
  PAYMENT_SUCCESS,
  PAYMENT_FAILURE,
  PAYMENT_PAYFORU_REQUEST,
  PAYMENT_PAYFORU_SUCCESS,
  PAYMENT_PAYFORU_FAILURE,
  PAYMENT_DEKNERD_PAYFORU_REQUEST,
  PAYMENT_DEKNERD_PAYFORU_SUCCESS,
  PAYMENT_DEKNERD_PAYFORU_FAILURE,
  ADD_WISHLIST_REQUEST,
  ADD_WISHLIST_SUCCESS,
  ADD_WISHLIST_FAILURE,
  EDIT_COURSE_FAILURE,
  EDIT_COURSE_REQUEST,
  EDIT_COURSE_SUCCESS,
  LOAD_PACKAGE_PAGES_FAILURE,
  LOAD_PACKAGE_PAGES_REQUEST,
  LOAD_PACKAGE_PAGES_SUCCESS,
  CHECK_PAYMENT_STATUS_FAILURE,
  CHECK_PAYMENT_STATUS_REQUEST,
  CHECK_PAYMENT_STATUS_SUCCESS,
  CLEAR_QRCODE_SUCCESS,
  LOAD_LESSON_REQUEST,
  LOAD_LESSON_SUCCESS,
  LOAD_LESSON_FAILURE,
  SAVE_LESSON_REQUEST,
  SAVE_LESSON_SUCCESS,
  SAVE_LESSON_FAILURE,
} from './types'

import {
  REVIEW_EP,
  COURSE_REVIEWS_EP,
  PAYMENT_EP,
  EDIT_COURSE_EP,
  PAYMENT_PAYFORU_DEKNERD,
  PAYMENT_PAYFORU,
  COURSE_EP,
  CHECK_PAYMENT_STATUS,
  OVERVIEW_EXAM,
  INFO_EP,
} from '../constant'
import {
  loadExamOverview,
  loadInfoPages,
} from '../actions'
const headers = {
  'x-session-token': token,
  'server-name': 'deknerd',
}
export const loadCoursePage = (endpoint, tokenMobile = null) => {
  return (dispatch) => {
    dispatch({
      [CALL_API]: {
        endpoint,
        method: 'GET',
        headers: {
          'x-session-token': tokenMobile !== null ? tokenMobile :token,
          'server-name': 'deknerd',
        },
        types: [
          LOAD_COURSE_PAGES_REQUEST,
          {
            type: LOAD_COURSE_PAGES_SUCCESS,
            payload: async (action, state, res) => {
              const response = await res.json()
              dispatch({
                type: LOAD_PLAYLISTS_PLAYER,
                data: response,
              })
              return response
            },
          },
          LOAD_COURSE_PAGES_FAILURE,
        ],
      },
    })
  }
}
export const loadPackagePage = (endpoint) => {
  return (dispatch) => {
    dispatch({
      [CALL_API]: {
        endpoint,
        method: 'GET',
        headers,
        types: [
          LOAD_PACKAGE_PAGES_REQUEST,
          {
            type: LOAD_PACKAGE_PAGES_SUCCESS,
            payload: async (action, state, res) => {
              const response = await res.json()
              // dispatch({
              //   type: LOAD_PLAYLISTS_PLAYER,
              //   data: response,
              // })
              return response
            },
          },
          LOAD_PACKAGE_PAGES_FAILURE,
        ],
      },
    })
  }
}

export const submitReview = (form) => {
  const formData = new FormData()
  Object.keys(form).forEach((key) => {
    formData.append(key, form[key])
  })
  return (dispatch) => {
    dispatch({
      [CALL_API]: {
        endpoint: REVIEW_EP,
        method: 'POST',
        body: formData,
        headers,
        types: [SUBMIT_REVIEW_REQUEST,
          {
            type: SUBMIT_REVIEW_SUCCESS,
            payload: async (action, state, res) => {
              const response = await res.json()
              // window.location.href = response.url
              if (form['idComment'] !== undefined) {
                return { ...response, idComment: form['idComment'] }
              }
              // dispatch(replace(`/redirect?url=${response.url}`))
              return response
            },
          }
          , SUBMIT_REVIEW_FAILURE],
      },
    })
  }
}

export const deleteReview = (id) => {
  return (dispatch) => {
    dispatch({
      [CALL_API]: {
        endpoint: COURSE_REVIEWS_EP(id),
        method: 'DELETE',
        headers,
        types: [DELETE_REVIEW_REQUEST, DELETE_REVIEW_SUCCESS, DELETE_REVIEW_FAILURE],
      },
    })
  }
}

export const handleAddWishList = endpoint => ({
  [CALL_API]: {
    endpoint,
    method: 'PUT',
    headers,
    types: [
      ADD_WISHLIST_REQUEST, ADD_WISHLIST_SUCCESS, ADD_WISHLIST_FAILURE,
    ],
  },
})

export const cancelDialogReview = () => ({
  type: CANCEL_REVIEW_DIALOG,
})

export const cancelDialogRemoveReview = () => ({
  type: CANCEL_REMOVE_REVIEW_DIALOG,
})

export const buyProductHandle = (id, coinId) => {
  const form = new FormData()
  form.append('idProduct', id)
  form.append('idCoin', coinId)

  return (dispatch) => {
    dispatch({
      [CALL_API]: {
        endpoint: PAYMENT_EP,
        method: 'POST',
        headers,
        body: form,
        types: [
          PAYMENT_REQUEST,
          {
            type: PAYMENT_SUCCESS,
            payload: async (action, state, res) => {
              const response = await res.json()
              // window.location.href = response.url
              window.location.reload()
              // dispatch(replace(`/redirect?url=${response.url}`))
              return response
            },
          },
          // PAYMENT_FAILURE,
          {
            type: PAYMENT_FAILURE,
            payload: async (action, state, res) => {
              // const response = await res.json()
              let response = ''
              if (res.state === 402) {
                response = 'ผู้ใช้มีคอร์สเรียนนี้แล้ว'
              } else if (res.state === 403) {
                response = 'coin ไม่พอสำหรับซื้อคอร์สนี้'
              } else {
                response = 'ไม่สามารถซื้อคอร์สเรียนนี้ได้'
              }
              // window.location.href = response.url
              // dispatch(replace(`/redirect?url=${response.url}`))
              return response
            },
          },
        ],
      },
    })
  }
}
export const paymentPayforU = (paymentForm) => {
  const form = new FormData()
  form.append('MERCHANTCODE', paymentForm.MERCHANTCODE)
  form.append('amount', paymentForm.amount)
  form.append('backurl', paymentForm.backurl)
  form.append('dataMD5', paymentForm.dataMD5)
  form.append('email', paymentForm.email)
  form.append('firstname', paymentForm.firstname)
  form.append('lastname', paymentForm.lastname)
  form.append('paymentType', paymentForm.paymentType)
  form.append('productlist', paymentForm.productlist)
  form.append('ref', paymentForm.ref)
  form.append('refDate', paymentForm.refDate)
  //   MERCHANTCODE: "200000001191"
  // amount: 4000
  // backurl: "https://deknerd.com/successpayment/course/59f816aa5e7b5bfd3359e051"
  // dataMD5: "e7c063f92591eab95fbc998ffaae02bd"
  // email: "bigohm26Test@hotmail.com"
  // firstname: "นรงค์ฤทธิ์"
  // lastname: "ตั้งปฐมพงศ์"
  // paymentType: "ThaiQR"
  // productlist: "[S;1][5b617cf0081c773ac233f56a;จำนวนเชิงซ้อน ม.5 ระยะเวลา 120 วัน;1;4000][E;1]"
  // ref: 1547784284110
  // refDate: "2019-1-18"

  return (dispatch) => {
    dispatch({
      [CALL_API]: {
        endpoint: PAYMENT_PAYFORU,
        method: 'POST',
        body: form,
        types: [
          PAYMENT_PAYFORU_REQUEST,
          {
            type: PAYMENT_PAYFORU_SUCCESS,
            payload: async (action, state, res) => {
              const response = await res.json()
              // window.location.href = response.url
              // window.location.reload()
              // dispatch(replace(`/redirect?url=${response.url}`))
              return response
            },
          },
          // PAYMENT_FAILURE,
          {
            type: PAYMENT_PAYFORU_FAILURE,
            payload: async (action, state, res) => {
              // const response = await res.json()
              let response = ''
              if (res.state === 402) {
                response = 'ผู้ใช้มีคอร์สเรียนนี้แล้ว'
              } else if (res.state === 403) {
                response = 'coin ไม่พอสำหรับซื้อคอร์สนี้'
              } else {
                response = 'ไม่สามารถซื้อคอร์สเรียนนี้ได้'
              }
              // window.location.href = response.url
              // dispatch(replace(`/redirect?url=${response.url}`))
              return response
            },
          },
        ],
      },
    })
  }
}
export const checkPaymentStatus = (ref, productId, productType) => {
  const form = new FormData()
  form.append('ref', ref)

  return (dispatch) => {
    dispatch({
      [CALL_API]: {
        endpoint: CHECK_PAYMENT_STATUS,
        method: 'POST',
        headers,
        body: form,
        types: [
          CHECK_PAYMENT_STATUS_REQUEST,
          {
            type: CHECK_PAYMENT_STATUS_SUCCESS,
            payload: async (action, state, res) => {
              const response = await res.json()
              // window.location.href = response.url
              // window.location.reload()
              if (response !== null) {
                if (response.responsecode === "01") {
                  if (productType === "course") {
                    await dispatch(loadCoursePage(COURSE_EP(productId)))
                  } else if (productType === "package") {
                    await dispatch(loadPackagePage(COURSE_EP(productId)))
                  } else if (productType === "exam") {
                    await dispatch(loadExamOverview(OVERVIEW_EXAM(productId)))
                  } else if (productType === "live") {
                    await dispatch(loadInfoPages(INFO_EP))
                  }
                  // dispatch(replace(`/redirect?url=${response.url}`))
                }
              }
              return response
            },
          },
          CHECK_PAYMENT_STATUS_FAILURE,
        ],
      },
    })
  }
}
export const clearQrcode = () => ({
  type: CLEAR_QRCODE_SUCCESS,
})
export const buyProductFromPayforUHandle = (id, coinId, productType, tokenMobile = null) => {
  const form = new FormData()
  form.append('idProduct', id)
  form.append('idCoin', coinId)
  form.append('backurl', window.location.href)
  form.append('paymenttype', "ThaiQR")

  return (dispatch) => {
    dispatch({
      [CALL_API]: {
        endpoint: PAYMENT_PAYFORU_DEKNERD,
        method: 'POST',
        headers: {
          'x-session-token': tokenMobile !== null ? tokenMobile : token,
          'server-name': 'deknerd',
        },
        body: form,
        types: [
          PAYMENT_DEKNERD_PAYFORU_REQUEST,
          {
            type: PAYMENT_DEKNERD_PAYFORU_SUCCESS,
            payload: async (action, state, res) => {
              const response = await res.json()
              // window.location.href = response.url
              // window.location.reload()
              if (response.url !== undefined && response.url !== null) {
                // dispatch(replace(`/redirect?url=${response.url}`))

                let qrData = {
                  amount: 0,
                  qrcode_text: 'notBase64',
                  refId: "00000000",
                }

                if (productType === "course") {
                  await dispatch(loadCoursePage(COURSE_EP(id)))
                  await dispatch({
                    type: PAYMENT_PAYFORU_SUCCESS,
                    data: qrData,
                  })
                } else if (productType === "package") {
                  await dispatch(loadPackagePage(COURSE_EP(id)))
                  await dispatch({
                    type: PAYMENT_PAYFORU_SUCCESS,
                    data: qrData,
                  })
                } else if (productType === "exam") {
                  await dispatch(loadExamOverview(OVERVIEW_EXAM(id)))
                  await dispatch({
                    type: PAYMENT_PAYFORU_SUCCESS,
                    data: qrData,
                  })
                } else if (productType === "live") {
                  await window.location.replace(`/live/${id}/0`)
                }
                // else if(productType === "live"){
                //   await dispatch(loadInfoPages(INFO_EP))
                //   await dispatch({
                //     type: PAYMENT_PAYFORU_SUCCESS,
                //     data: qrData,
                //   })
                // }
              } else {
                let qrData = {
                  amount: response.split('&')[3].replace("amount=", ''),
                  qrcode_text: response.split('&')[8].replace("qrcode_text=", ''),
                  refId: response.split('&')[2].replace("ref=", '')
                }
                await dispatch({
                  type: PAYMENT_PAYFORU_SUCCESS,
                  data: qrData,
                })
                // await dispatch(paymentPayforU(response))
              }
              return response
            },
          },
          // PAYMENT_FAILURE,
          {
            type: PAYMENT_DEKNERD_PAYFORU_FAILURE,
            payload: async (action, state, res) => {
              // const response = await res.json()
              let response = ''
              if (res.state === 402) {
                response = 'ผู้ใช้มีคอร์สเรียนนี้แล้ว'
              } else if (res.state === 403) {
                response = 'coin ไม่พอสำหรับซื้อคอร์สนี้'
              } else {
                response = 'ไม่สามารถซื้อคอร์สเรียนนี้ได้'
              }
              // window.location.href = response.url
              // dispatch(replace(`/redirect?url=${response.url}`))
              return response
            },
          },
        ],
      },
    })
  }
}

export const buyProductFreeHandle = (id, coinId) => {
  const form = new FormData()
  form.append('idProduct', id)
  form.append('idCoin', coinId)
  return (dispatch) => {
    dispatch({
      [CALL_API]: {
        endpoint: PAYMENT_EP,
        method: 'POST',
        headers,
        body: form,
        types: [
          PAYMENT_REQUEST,
          {
            type: PAYMENT_SUCCESS,
            payload: async (action, state, res) => {
              const response = await res.json()
              // window.location.href = response.url
              // window.location.reload()
              // dispatch(replace(`/redirect?url=${response.url}`))
              // let pathName = `/eTestingExample/${_id}`
              await sessionStorage.setItem('startExam', 'true')
              await sessionStorage.setItem('loadExamFirst', 'true')
              await sessionStorage.setItem('typeExam', `/testExam/${id}`)
              await sessionStorage.setItem('testExam', 'true')
              window.location.replace(`/eTestingExample/${id}`)
              return response
            },
          },
          // PAYMENT_FAILURE,
          {
            type: PAYMENT_FAILURE,
            payload: async (action, state, res) => {
              // const response = await res.json()
              let response = ''
              if (res.state === 402) {
                response = 'ผู้ใช้มีคอร์สเรียนนี้แล้ว'
              } else if (res.state === 403) {
                response = 'coin ไม่พอสำหรับซื้อคอร์สนี้'
              } else {
                response = 'ไม่สามารถซื้อคอร์สเรียนนี้ได้'
              }
              // window.location.href = response.url
              // dispatch(replace(`/redirect?url=${response.url}`))
              return response
            },
          },
        ],
      },
    })
  }
}
export const buyProductHandleCode = (id, code) => {
  const form = new FormData()
  form.append('idProduct', id)
  // form.append('idCoin', null)
  form.append('code', code)
  return (dispatch) => {
    dispatch({
      [CALL_API]: {
        endpoint: PAYMENT_EP,
        method: 'POST',
        headers,
        body: form,
        types: [
          PAYMENT_REQUEST,
          {
            type: PAYMENT_SUCCESS,
            payload: async (action, state, res) => {
              const response = await res.json()
              // window.location.href = response.url
              // window.location.href = `/testExam/${id}`
              // window.location.replace(`/testExam/${id}/${code}`)
              window.location.replace(`/testExam/${id}/${code}`)
              // window.location.reload()
              // dispatch(replace(`/redirect?url=${response.url}`))
              return response
            },
          },
          // PAYMENT_FAILURE,
          {
            type: PAYMENT_FAILURE,
            payload: async (action, state, res) => {
              // const response = await res.json()
              let response = ''
              if (res.state === 402) {
                // response = 'ผู้ใช้มีข้อสอบนี้แล้ว'
                response = 'คูปองนี้ไม่สามารถใช้งานได้'
              } else if (res.state === 403) {
                // response = 'coin ไม่พอสำหรับซื้อคอร์สนี้'
                response = 'คูปองนี้ไม่สามารถใช้งานได้'
              } else {
                response = 'คูปองนี้ไม่สามารถใช้งานได้'
                // response = 'ไม่สามารถซื้อข้อสอบนี้ได้'
              }
              // window.location.href = response.url
              // dispatch(replace(`/redirect?url=${response.url}`))
              return response
            },
          },
        ],
      },
    })
  }
}

export const handleEditCourse = (courseData) => {
  const form = new FormData()
  Object.keys(courseData).map((keyCourse) => {
    return courseData[keyCourse] instanceof Array ? (
      // courseData[keyCourse].map(value => form.append(`${keyCourse}[]`, value))
      courseData[keyCourse].map(value => form.append(`${keyCourse}`, value.key))
    )
      : form.append(keyCourse, courseData[keyCourse])
  })
  return {
    [CALL_API]: {
      endpoint: EDIT_COURSE_EP,
      method: 'PUT',
      headers,
      body: form,
      types: [
        EDIT_COURSE_REQUEST,
        EDIT_COURSE_SUCCESS,
        EDIT_COURSE_FAILURE,
      ],
    },
  }
}
export const loadLessonPage = (endpoint) => {
  return {
    [CALL_API]: {
      endpoint: endpoint,
      method: 'GET',
      // headers: {
      //   'x-session-token': token,
      // },
      types: [
        LOAD_LESSON_REQUEST,
        LOAD_LESSON_SUCCESS,
        LOAD_LESSON_FAILURE,
      ],
    },
  }
}
export const submitLessonFinish = (endpoint, tokenMobile = null) => {
  sessionStorage.removeItem('lectureId')
  return {
    [CALL_API]: {
      endpoint: endpoint,
      method: 'GET',
      headers: {
        'x-session-token': tokenMobile !== null ?  tokenMobile: token,
        'server-name': 'deknerd',
      },
      types: [
        SAVE_LESSON_REQUEST,
        SAVE_LESSON_SUCCESS,
        SAVE_LESSON_FAILURE,
      ],
    },
  }
}




// WEBPACK FOOTER //
// ./src/actions/course.js